/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationAnticipation200Response
 */
export interface GetReservationAnticipation200Response {
    /**
     * 
     * @type {number}
     * @memberof GetReservationAnticipation200Response
     */
    beforeTime: number;
    /**
     * 
     * @type {number}
     * @memberof GetReservationAnticipation200Response
     */
    afterTime: number;
    /**
     * 
     * @type {string}
     * @memberof GetReservationAnticipation200Response
     */
    beforeUnit: GetReservationAnticipation200ResponseBeforeUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof GetReservationAnticipation200Response
     */
    afterUnit: GetReservationAnticipation200ResponseAfterUnitEnum;
}


/**
 * @export
 */
export const GetReservationAnticipation200ResponseBeforeUnitEnum = {
    Minutes: 'minutes',
    Hours: 'hours',
    Days: 'days'
} as const;
export type GetReservationAnticipation200ResponseBeforeUnitEnum = typeof GetReservationAnticipation200ResponseBeforeUnitEnum[keyof typeof GetReservationAnticipation200ResponseBeforeUnitEnum];

/**
 * @export
 */
export const GetReservationAnticipation200ResponseAfterUnitEnum = {
    Minutes: 'minutes',
    Hours: 'hours',
    Days: 'days'
} as const;
export type GetReservationAnticipation200ResponseAfterUnitEnum = typeof GetReservationAnticipation200ResponseAfterUnitEnum[keyof typeof GetReservationAnticipation200ResponseAfterUnitEnum];


/**
 * Check if a given object implements the GetReservationAnticipation200Response interface.
 */
export function instanceOfGetReservationAnticipation200Response(value: object): value is GetReservationAnticipation200Response {
    if (!('beforeTime' in value) || value['beforeTime'] === undefined) return false;
    if (!('afterTime' in value) || value['afterTime'] === undefined) return false;
    if (!('beforeUnit' in value) || value['beforeUnit'] === undefined) return false;
    if (!('afterUnit' in value) || value['afterUnit'] === undefined) return false;
    return true;
}

export function GetReservationAnticipation200ResponseFromJSON(json: any): GetReservationAnticipation200Response {
    return GetReservationAnticipation200ResponseFromJSONTyped(json, false);
}

export function GetReservationAnticipation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationAnticipation200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'beforeTime': json['beforeTime'],
        'afterTime': json['afterTime'],
        'beforeUnit': json['beforeUnit'],
        'afterUnit': json['afterUnit'],
    };
}

export function GetReservationAnticipation200ResponseToJSON(json: any): GetReservationAnticipation200Response {
    return GetReservationAnticipation200ResponseToJSONTyped(json, false);
}

export function GetReservationAnticipation200ResponseToJSONTyped(value?: GetReservationAnticipation200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'beforeTime': value['beforeTime'],
        'afterTime': value['afterTime'],
        'beforeUnit': value['beforeUnit'],
        'afterUnit': value['afterUnit'],
    };
}

